import api from "../../../services/axiosConfig";

export const fetchProjects = async () => {
  try {
    const response = await api.get("/projects/all", {
      data: {},
    });
    return response.data.data.projects;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

export const fetchMyProjects = async () => {
  try {
    const response = await api.get("/projects/my-projects", { data: {} });
    const { myCreatedProjects = [], collaboratingProjects = [] } =
      response.data.data;

    const transform = (project, type) => ({
      id: project.id,
      title: project.title,
      description: project.description,
      status: project.status,
      progress: project.progress,
      created: project.createdAt,
      owner: project.owner,
      collaborators: project.collaborators,
      modules: project.modules,
      projectType: type,
    });

    return {
      myCreatedProjects: myCreatedProjects.map((p) => transform(p, "owned")),
      collaboratingProjects: collaboratingProjects.map((p) =>
        transform(p, "collaborating"),
      ),
    };
  } catch (error) {
    console.error("Error fetching my projects:", error);
    throw error;
  }
};

export const createProject = async (projectData) => {
  try {
    const response = await api.post("/projects/create", projectData);
    return response.data;
  } catch (error) {
    console.error("Error creating project:", error);
    throw error;
  }
};

export const deleteProject = async (projectId) => {
  try {
    const response = await api.delete(`/projects/${projectId}`, {
      data: {},
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};

export const fetchUsers = async () => {
  try {
    const response = await api.get("/users", {
      data: {},
    });
    return response.data.data.users;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const updateProject = async (projectId, projectData) => {
  try {
    const response = await api.put(`/projects/${projectId}`, projectData);
    return response.data;
  } catch (error) {
    console.error("Error updating project:", error);
    throw error;
  }
};

export const fetchModuleResources = async (moduleName) => {
  const endpointMap = {
    skeyenote: "instances/skeye/skeyenote/list-notes",
    skeyechart: "instances/skeye/skeyechart/dashboards",
    skeyeingest: "instances/skeye/skeyeingest/list-pipelines",
    skeyecube: "instances/skeye/skeyecube/list-projects",
    skeyepredict: "instances/skeye/skeyepredict/list-projects",
    jeyeda: "instances/governeye/jeyeda/list-projects",
  };

  const endpoint = endpointMap[moduleName];
  if (!endpoint) return null;

  const response = await api.get(endpoint, { data: {} });
  return response.data;
};

export const linkModuleResources = async (projectId, moduleName, payload) => {
  const response = await api.post(
    `/projects/${projectId}/modules/${moduleName}/link`,
    payload,
  );
  return response.data;
};

export const unlinkModuleResource = async (
  projectId,
  moduleName,
  resourceId,
) => {
  const response = await api.delete(
    `/projects/${projectId}/modules/${moduleName}/${resourceId}/unlink`,
    { data: {} },
  );
  return response.data;
};
